import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik";
import { AddnewUsers } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const mcxSymbols = [
  "NATGASMINI",
  "SILVERM",
  "GOLDM",
  "SILVER",
  "GOLD",
  "COPPER",
  "CRUDEOIL",
  "CRUDEOILM",
  "NATURALGAS",
  "ZINC",
];
const AddEmployee = () => {
  const TokenData = getUserFromToken();
  const navigate = useNavigate();
  const Role = TokenData?.Role;
  const user_id = TokenData?.user_id;

  const formik = useFormik({
    initialValues: {
      fullName: "",
      username: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      parent_id: "",
      parent_role: "",
      Role: "",
      all: false,
      addclient: false,
      Edit: false,
      trade_history: false,
      open_position: false,
      limit_edit: false,
      Balance_edit: false,
      market: [],
        mcxEnabled: false,      
  mcxData: {},            
    },

    validate: (values) => {
      let errors = {};
      if (!values.fullName) {
        errors.fullName = "Please Enter Full Name";
      }
      if (!values.username) {
        errors.username = "Please Enter Username";
      }
      if (!values.email) {
        errors.email = "Please enter your email address";
      } else if (
        !/^[a-zA-Z][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(values.email)
      ) {
        errors.email = "Please enter a valid email address (must start with a letter)";
      }

      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      } else if (!/^\d{10}$/.test(values.phone)) {
        errors.phone = "Please enter a valid 10-digit phone number.";
      }

      if (!values.password) {
        errors.password = "Please Enter Password";
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Please Confirm Password";
      } else if (values.password !== values.confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }

      if (values.market.length === 0) {
        errors.market = "Please select at least one market";
      }

      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      const data = {
        FullName: values.fullName,
        UserName: values.username,
        Email: values.email,
        PhoneNo: values.phone,

        password: values.password,
        parent_role: Role || "ADMIN",
        parent_id: user_id,
        Role: "EMPLOYE",
        market: values.market,
         mcx: values.mcxEnabled
    ? values.mcxData
    : null,
        Employee_permission: {
          client_add: values.addclient || values.all ? "1" : "0",
          Edit: values.Edit || values.all ? "1" : "0",
          trade_history: values.trade_history || values.all ? "1" : "0",
          open_position: values.open_position || values.all ? "1" : "0",

          limit_edit: values.limit_edit || values.all ? "1" : "0",
          Balance_edit: values.Balance_edit || values.all ? "1" : "0",
        },
      };

      setSubmitting(false);

      await AddnewUsers(data)
        .then((response) => {
          if (response.status) {
            Swal.fire({
              title: "Employe Added!",
              text: "Employe added successfully",
              icon: "success",
              timer: 1000,
              timerProgressBar: true,
            });
            setTimeout(() => {
              navigate("/admin/employee");
            }, 1000);
          } else {
            Swal.fire({
              title: "Error!",
              text: response.message || "Employe add error",
              icon: "error",
              timer: 1000,
              timerProgressBar: true,
            });
          }
        })
        .catch((error) => { });
    },
    onChange: (e) => {
      const { name, checked } = e.target;
      formik.setFieldValue(name, checked);
      if (name === "all") {
        formik.setFieldValue("addclient", checked);
        formik.setFieldValue("Edit", checked);
        formik.setFieldValue("trade_history", checked);
        formik.setFieldValue("open_position", checked);

        formik.setFieldValue("limit_edit", checked);
        formik.setFieldValue("Balance_edit", checked);
      }
    },
  });

  useEffect(() => {
    const {
      addclient,
      Edit,
      trade_history,
      open_position,

      limit_edit,
      Balance_edit,
    } = formik.values;

    const allSelected =
      addclient &&
      Edit &&
      trade_history &&
      open_position &&

      limit_edit &&
      Balance_edit;

    if (formik.values.all == allSelected) {
      formik.setFieldValue("all", allSelected);
    }
  }, [
    formik.values.addclient,
    formik.values.Edit,
    formik.values.trade_history,
    formik.values.open_position,

    formik.values.limit_edit,
    formik.values.Balance_edit,
    formik.values.all,
  ]);

  const fields = [
    { type: "heading", label: "Basic Details", col_size: 12 },
    {
      name: "fullName",
      label: "Full Name",
      type: "text",
      label_size: 6,
      col_size: 6,
      disable: false,
    },
    {
      name: "username",
      label: "Username",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "text3",
      label_size: 12,
      col_size: 6,
      disable: false,
    },

    {
      name: "password",
      label: "Password",
      type: "password",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "confirmPassword",
      label: "Confirm Password",
      type: "password",
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "permissionsHeading",
      label: "Permissions",
      type: "heading",
      label_size: 12,
      col_size: 12,
      disable: true,
    },

    {
      name: "addclient",
      label: "Add Client",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true:
        formik.values.all || formik.values.addclient ? true : false,
    },
    {
      name: "Edit",
      label: "Edit",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.all || formik.values.Edit ? true : false,
    },
    {
      name: "trade_history",
      label: "Trade History",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true:
        formik.values.all || formik.values.trade_history ? true : false,
    },
    {
      name: "open_position",
      label: "Open Position",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true:
        formik.values.all || formik.values.open_position ? true : false,
    },

    {
      name: "limit_edit",
      label: "Limit Edit",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true:
        formik.values.all || formik.values.limit_edit ? true : false,
    },
    {
      name: "Balance_edit",
      label: "Balance Edit",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true:
        formik.values.all || formik.values.Balance_edit ? true : false,
    },
    { type: "heading", label: "Select Market", col_size: 8 },

  ];

  return (
    <Form
      fields={fields.filter(
        (field) => !field.showWhen || field.showWhen(formik.values)
      )}
      page_title="Add Employee"
      btn_name="Add Employee"
      btn_name1="Cancel"
      formik={formik}
      btn_name1_route={"/admin/employee"}
      additional_field={
        // <div className="col-lg-8 mt-4">
        //   <label className="fw-bold mb-2">Select Markets</label>
        //   <div className="d-flex gap-4 align-items-center">
        //     {/* Forex */}
        //     {TokenData?.market?.includes(0) &&
        //       <div className="form-check">
        //         <input
        //           type="checkbox"
        //           className="form-check-input"
        //           id="market-forex"
        //           checked={formik.values.market.includes(0)}
        //           onChange={(e) => {
        //             if (e.target.checked) {
        //               formik.setFieldValue("market", [...formik.values.market, 0]);
        //             } else {
        //               formik.setFieldValue("market", formik.values.market.filter((m) => m !== 0));
        //             }
        //           }}
        //         />
        //         <label className="form-check-label fw-semibold" htmlFor="market-forex">Forex</label>
        //       </div>}

        //     {/* India */}
        //     {TokenData?.market?.includes(1) && <div className="form-check">
        //       <input
        //         type="checkbox"
        //         className="form-check-input"
        //         id="market-india"
        //         checked={formik.values.market.includes(1)}
        //         onChange={(e) => {
        //           if (e.target.checked) {
        //             formik.setFieldValue("market", [...formik.values.market, 1]);
        //           } else {
        //             formik.setFieldValue("market", formik.values.market.filter((m) => m !== 1));
        //           }
        //         }}
        //       />
        //       <label className="form-check-label fw-semibold" htmlFor="market-india">India</label>
        //     </div>}
        //   </div>

        //   {formik.errors.market && (
        //     <div className="text-danger mt-2 small">{formik.errors.market}</div>
        //   )}

        // </div>
        <div className="col-lg-12  ">
          <div
            className="px-3 rounded-4 shadow-sm "
            style={{
              background: "#ffffff",
              borderColor: "#e7e7e7",
            }}
          >
            <div className="d-flex gap-3 flex-wrap">

              {/* Forex */}
              {TokenData?.market?.includes(0) && (
                <div
                  onClick={() => {
                    const isSelected = formik.values.market.includes(0);
                    if (isSelected) {
                      formik.setFieldValue(
                        "market",
                        formik.values.market.filter((m) => m !== 0)
                      );
                    } else {
                      formik.setFieldValue("market", [...formik.values.market, 0]);
                    }
                  }}
                  className="px-4 py-2 rounded-pill shadow-sm cursor-pointer premium-chip"
                  style={{
                    fontWeight: 600,
                    border: formik.values.market.includes(0)
                      ? "2px solid #3b82f6"
                      : "2px solid #d5d5d5",
                    background: formik.values.market.includes(0)
                      ? "#e8f1ff"
                      : "#fafafa",
                    transition: "0.2s",
                  }}
                >
                  Forex
                </div>
              )}

              {/* India */}
              {TokenData?.market?.includes(1) && (
                <div
                  onClick={() => {
                    const isSelected = formik.values.market.includes(1);
                    if (isSelected) {
                      formik.setFieldValue(
                        "market",
                        formik.values.market.filter((m) => m !== 1)
                      );
                    } else {
                      formik.setFieldValue("market", [...formik.values.market, 1]);
                    }
                  }}
                  className="px-4 py-2 rounded-pill shadow-sm cursor-pointer premium-chip"
                  style={{
                    fontWeight: 600,
                    border: formik.values.market.includes(1)
                      ? "2px solid #3b82f6"
                      : "2px solid #d5d5d5",
                    background: formik.values.market.includes(1)
                      ? "#e8f1ff"
                      : "#fafafa",
                    transition: "0.2s",
                  }}
                >
                  India
                </div>
              )}
            </div>

            {formik.errors.market && (
              <div className="text-danger mt-2 small fw-semibold">
                {formik.errors.market}
              </div>
            )}


               {/* India selected hone ke baad button */}
{formik.values.market.includes(1) && (
  <div className="mt-3">
    <button
      type="button"
      className="btn btn-primary btn-sm"
      onClick={() =>
        formik.setFieldValue("mcxEnabled", !formik.values.mcxEnabled)
      }
    >
      Add MCX Symbols
    </button>
  </div>
)}
  

{/* MCX INPUT SECTION – FULL WIDTH */}
{formik.values.market.includes(1) && formik.values.mcxEnabled && (
  <div className="row mt-4">
    <div className="col-12">

      <div className="p-3  rounded shadow ">
        <h6 className="fw-bold mb-3">MCX Symbols</h6>

        <div className="row">
          {mcxSymbols.map((symbol) => (
            <div key={symbol} className="col-md-4 col-sm-6 mb-3">
              <label className="form-label fw-semibold">
                {symbol}
              </label>

              <input
                type="number"
                className="form-control"
                placeholder={symbol}
                value={formik.values.mcxData?.[symbol] || ""}
                onChange={(e) => {
                  formik.setFieldValue("mcxData", {
                    ...formik.values.mcxData,
                    [symbol]: e.target.value,
                  });
                }}
              />
            </div>
          ))}
        </div>

      </div>

    </div>
  </div>
)}

          </div>
        </div>

      }
    />
  );
};

export default AddEmployee;
